import PlanejamentoAcaoDados from '../../../produto/spa/planejamento-acao/list/PlanejamentoAcaoDados';

export default PlanejamentoAcaoDados;
